import React from 'react';
import * as S from './styles';
import UpgradeDetailsOnly from '../UpgradeDetailsOnly';
import ActionItemsList from '../ActionItemsList';
import NextStepsSection from '../NextStepsSection';
import { useTranslationHelper } from 'src/contexts/dependencyManager/utils';
import { IconChevronRight, InlineNotification } from '@veneer/core';

const UpgradeConfirmation: React.FC = () => {
  const getText = useTranslationHelper();

  return (
    <S.Container>
      <S.HeaderContainer>
        <S.MainTitle>
          {getText('confirmation.title', 'Your upgrade is confirmed!')}
        </S.MainTitle>
      </S.HeaderContainer>

      <S.MainContent>
        <S.ContentSection>
          <UpgradeDetailsOnly />
          <S.NotificationItem>
            <InlineNotification
              type="informative"
              closeButton={false}
              title={getText(
                'confirmation.checkItem1',
                'Continue to use your current printer.'
              )}
              description={getText(
                'confirmation.checkItem2',
                'Your new printer will be delivered to your door within 2 business days.'
              )}
            />
          </S.NotificationItem>
          <ActionItemsList orderNumber="3902720836" />
        </S.ContentSection>
      </S.MainContent>

      <NextStepsSection />

      <S.SurveySectionWrapper>
        <S.SurveySection>
          <S.SurveyText>
            {getText(
              'confirmation.giveFeedback',
              'Give us your feedback with a quick survey'
            )}
          </S.SurveyText>
          <IconChevronRight filled />
        </S.SurveySection>
      </S.SurveySectionWrapper>
    </S.Container>
  );
};

export default UpgradeConfirmation;
